export default "__VITE_ASSET__CIkwJe8Y__"